module.exports = __webpack_public_path__ + "static/AngelaHe12-8f269464fdce26fed25fe7e72b7dc69b.png";